<div
  class="main-form-container"
  [ngStyle]="{ 'max-width.%': formConfig.maxWidth ? formConfig.maxWidth : 100 }"
>
  <!-- Loader -->
  <pp-loader *ngIf="isLoad"></pp-loader>
  <!-- Loader -->

  <!-- Header -->
  <div *ngIf="header">
    <h2>{{ header }}</h2>
  </div>
  <!-- Header -->

  <!-- Form  -->
  <form [formGroup]="form" *ngIf="form">
    <!-- Form Fields with recursion for groups -->
    <ng-container
      *ngTemplateOutlet="
        formFieldTemplate;
        context: {
          fields: formFields,
          formGrp: form,
          columnPerRow: columnPerRow
        }
      "
    >
    </ng-container>
    <!-- Form Fields with recursion for groups -->
  </form>
  <!-- Form  -->
  <!-- Form Buttons  -->
  <div *ngIf="form" class="form-buttons">
    <pp-button
      *ngIf="formButton"
      [disabled]="
        disableSubmitButton || (stepperForm ? !stepperForm : !form.dirty)
      "
      [buttonConfig]="formButton"
      (onClick)="onSubmit()"
    ></pp-button>

    <pp-button
      *ngIf="backButton"
      [buttonConfig]="backButton"
      (onClick)="back()"
      class="back-button"
    ></pp-button>
  </div>
  <br />
  <p *ngIf="errorMsg" style="color: red">*{{ errorMsg }}</p>
  <!-- Form Buttons  -->
</div>

<!-- Form Fields -->
<ng-template
  #formFieldTemplate
  let-fields="fields"
  let-form="formGrp"
  let-columnPerRow="columnPerRow"
>
  <div [formGroup]="form" class="form-container">
    <ng-container *ngFor="let control of fields">
      <div
        *ngIf="
          !control.isHidden &&
          control.type !== 'hidden' &&
          displayValidate(control, form)
        "
        class="form-fields"
        [ngStyle]="{
          width:
            control.type === 'rich-textarea'
              ? 100 + '%'
              : control.type === 'group'
                ? 100 + '%'
                : control.type === 'array'
                  ? 100 + '%'
                  : 100 / columnPerRow + '%'
        }"
      >
        <ng-container ngSwitch="{{ control.type }}">
          <!-- Text -->
          <mat-form-field
            *ngSwitchCase="'text'"
            [appearance]="control.outline ? 'outline' : 'standard'"
          >
            <mat-label>
              {{ control.placeholder }}
              <span *ngIf="control.required?.value"> *</span>
            </mat-label>
            <input
              matInput
              (keyup)="
                control.fieldChangeCapture
                  ? patchValueOnAnotherField(control)
                  : ''
              "
              [formControlName]="control.name"
              (ngModelChange)="formValueChange(control, form)"
              [readonly]="control?.disabled"
              [attr.disabled]="control?.disabled"
            />
            <pp-icon
              matPrefix
              *ngIf="control.prefixIcon"
              [iconConfig]="control.prefixIcon"
            ></pp-icon>
            <pp-icon
              matSuffix
              *ngIf="control.suffixIcon"
              [iconConfig]="control.suffixIcon"
            ></pp-icon>
          </mat-form-field>
          <!-- Text -->

          <!-- Textarea -->
          <mat-form-field
            *ngSwitchCase="'textarea'"
            [appearance]="control.outline ? 'outline' : 'standard'"
          >
            <mat-label>
              {{ control.placeholder }}
              <span *ngIf="control.required?.value"> *</span>
            </mat-label>
            <textarea
              matInput
              [formControlName]="control.name"
              (ngModelChange)="formValueChange(control, form)"
              [readonly]="control?.disabled"
              [attr.disabled]="control?.disabled"
            ></textarea>
            <pp-icon
              matPrefix
              *ngIf="control.prefixIcon"
              [iconConfig]="control.prefixIcon"
            ></pp-icon>
            <pp-icon
              matSuffix
              *ngIf="control.suffixIcon"
              [iconConfig]="control.suffixIcon"
            ></pp-icon>
          </mat-form-field>
          <!-- Textarea -->

          <!-- Number -->
          <mat-form-field
            *ngSwitchCase="'number'"
            [appearance]="control.outline ? 'outline' : 'standard'"
          >
            <mat-label>
              {{ control.placeholder }}
              <span *ngIf="control.required?.value"> *</span>
            </mat-label>
            <input
              matInput
              type="number"
              [formControlName]="control.name"
              (ngModelChange)="formValueChange(control, form)"
              [readonly]="control?.disabled"
              [attr.disabled]="control?.disabled"
            />
            <pp-icon
              matPrefix
              *ngIf="control.prefixIcon"
              [iconConfig]="control.prefixIcon"
            ></pp-icon>
            <pp-icon
              matSuffix
              *ngIf="control.suffixIcon"
              [iconConfig]="control.suffixIcon"
            ></pp-icon>
          </mat-form-field>
          <!-- Number -->

          <!-- Password -->
          <mat-form-field
            *ngSwitchCase="'password'"
            [appearance]="control.outline ? 'outline' : 'standard'"
          >
            <mat-label>
              {{ control.placeholder }}
              <span *ngIf="control.required?.value"> *</span>
            </mat-label>
            <input
              #passwordField
              matInput
              type="password"
              [formControlName]="control.name"
              (ngModelChange)="formValueChange(control, form)"
              [readonly]="control?.disabled"
              [attr.disabled]="control?.disabled"
            />
            <button
              matSuffix
              mat-icon-button
              (click)="
                passwordField.type =
                  passwordField.type === 'password' ? 'text' : 'password'
              "
              matTooltip="{{
                passwordField.type === 'password'
                  ? 'Show Password'
                  : 'Hide Password'
              }}"
            >
              <mat-icon *ngIf="passwordField.type === 'password'"
                >visibility</mat-icon
              >
              <mat-icon *ngIf="passwordField.type === 'text'"
                >visibility_off</mat-icon
              >
            </button>
          </mat-form-field>
          <!-- Password -->

          <!-- Select -->
          <mat-form-field
            *ngSwitchCase="'select'"
            [appearance]="control.outline ? 'outline' : 'standard'"
            class="select-form-field"
          >
            <mat-label appRemoveAriaOwns>
              {{ control.placeholder }}
              <span *ngIf="control.required?.value"> *</span>
              <ng-container *ngIf="selectApiLoading[control.controlId]">
                (Loading...)
              </ng-container>
            </mat-label>
            <mat-select
              msInfiniteScroll
              (infiniteScroll)="onScroll(control)"
              [complete]="control.select?.offSetComplete"
              [threshold]="'0px'"
              [formControlName]="control.name"
              [multiple]="
                control.multipleSelect ? control.multipleSelect : false
              "
              (ngModelChange)="
                formValueChange(control, form);
                control.fieldChangeCapture
                  ? patchValueOnAnotherField(control)
                  : ''
              "
              [disabled]="control?.disabled"
            >
              <mat-option
                class="hide-checkbox"
                (click)="openPpFormModal(control)"
                *ngIf="control.select && control.select.needAddButton"
              >
                {{ control?.select?.addButtonConfig?.buttonName }}
              </mat-option>
              <div class="select-search-and-loader-container">
                <mat-option
                  class="select-search-option"
                  *ngIf="control.select && control.select.searchable"
                >
                  <div
                    *ngIf="
                      control.select?.api &&
                      !isSelectCurrentValueOptionsLoaded(control)
                    "
                    class="select-search-disable-overlay"
                  ></div>
                  <ngx-mat-select-search
                    ignoreDirty
                    [formControlName]="
                      control.controlId + '_dropdownSearchText'
                    "
                    (ngModelChange)="onSelectSearchTextChange($event, control)"
                    [placeholderLabel]="
                      control.select?.searchConfig?.placeholder ?? 'Search'
                    "
                    [disableScrollToActiveOnOptionsChanged]="true"
                    [clearSearchInput]="false"
                    [searching]="false"
                    [disableInitialFocus]="
                      control.select?.api &&
                      !isSelectCurrentValueOptionsLoaded(control)
                    "
                    noEntriesFoundLabel="No results found"
                  >
                  </ngx-mat-select-search>
                </mat-option>
                <div
                  *ngIf="selectApiLoading[control.controlId]"
                  class="select-search-loader"
                ></div>
              </div>
              <ng-container *ngIf="!control.multipleSelect">
                <mat-option value="">{{ control.placeholder }}</mat-option>
              </ng-container>

              <mat-checkbox
                class="select-all"
                [color]="'primary'"
                *ngIf="control.multipleSelect && control.selectAll"
                (change)="toggleSelectAll(control)"
                [checked]="
                  control.formControl?.value?.length === control?.values?.length
                "
                [indeterminate]="
                  control.formControl?.value?.length > 0 &&
                  control.formControl?.value?.length !== control?.values?.length
                "
              >
                Select All
              </mat-checkbox>
              <mat-option
                *ngFor="let each of control.values"
                [value]="each.value"
                [disabled]="isOptionDisabled(each.value, control, form)"
                [ngStyle]="{
                  color: each?.color
                }"
              >
                <span *ngIf="each.viewValue">{{ each.viewValue }}</span>
                <span
                  *ngIf="each.secondaryViewValue"
                  [innerHTML]="each.secondaryViewValue"
                >
                </span>
              </mat-option>
            </mat-select>
            <pp-icon
              matPrefix
              *ngIf="control.prefixIcon"
              [iconConfig]="control.prefixIcon"
            ></pp-icon>
            <pp-icon
              matSuffix
              *ngIf="control.suffixIcon"
              [iconConfig]="control.suffixIcon"
            ></pp-icon>
            <mat-hint
              *ngIf="selectApiError[control.controlId] !== ''"
              align="start"
              class="select-api-error-message"
              [ngClass]="{
                'shift-select-error-message':
                  isPermissionError(control) &&
                  !!control.permissionNames?.length
              }"
            >
              <div
                *ngIf="!isPermissionError(control)"
                [matTooltip]="selectApiError[control.controlId]"
              >
                {{ selectApiError[control.controlId] }}
              </div>
              <div
                *ngIf="isPermissionError(control)"
                [matTooltip]="
                  getPermissionNameToDisplay(control) ||
                  'You do not have permission to access this field'
                "
                class="permission-error-message"
              >
                You do not have permission to access this field.
                <mat-icon
                  class="permission-copy-icon"
                  *ngIf="!!control.permissionNames?.length"
                  (click)="copyPermissionName(control)"
                  >content_copy</mat-icon
                >
              </div>
            </mat-hint>
            <mat-hint
              *ngIf="control?.multipleSelect && control?.selectionLimit?.value"
              align="end"
              [matTooltip]="control?.selectionLimit?.message"
              class="relative-disabled-message"
            >
              {{ control?.selectionLimit?.message }}
            </mat-hint>
          </mat-form-field>
          <ng-container *ngSwitchCase="'select'">
            <div
              *ngIf="control?.helperText"
              style="
                display: flex;
                gap: 2px;
                align-items: center;
                font-size: 12px;
              "
            >
              <mat-icon style="font-size: 12px; width: 12px; height: 12px"
                >info</mat-icon
              >
              <div [innerHTML]="control.helperText | safe: 'html'"></div>
            </div>
          </ng-container>

          <!-- Select -->

          <!-- Radio -->
          <ng-container *ngSwitchCase="'radio'">
            <label id="example-radio-group-label">
              {{ control.placeholder }}
            </label>
            <div>
              <mat-radio-group
                aria-label="Radio"
                [formControlName]="control.name"
                (ngModelChange)="formValueChange(control, form)"
                [attr.disabled]="control?.disabled"
              >
                <mat-radio-button
                  [value]="each.value"
                  *ngFor="let each of control.values"
                >
                  {{ each.viewValue }}
                </mat-radio-button>
              </mat-radio-group>
            </div>
          </ng-container>
          <!-- Radio -->

          <!-- Checkbox -->
          <ng-container *ngSwitchCase="'checkbox'">
            <ng-container *ngIf="control.checkbox; else defaultCheckbox">
              <mat-checkbox
                (change)="
                  $event.checked
                    ? form.controls[control.name].setValue(
                        control.checkbox?.activeValue
                      )
                    : form.controls[control.name].setValue(
                        control.checkbox?.inActiveValue
                      );
                  formValueChange(control, form)
                "
                [checked]="
                  form.controls[control.name].value ===
                  control.checkbox?.activeValue
                "
                [disabled]="control?.disabled"
              >
                {{ control.placeholder }}

                <ng-container *ngIf="control?.checkbox?.text">
                  <ng-container
                    *ngIf="
                      form.controls[control.name].value ===
                        control.checkbox?.activeValue &&
                      control?.checkbox?.text?.active
                    "
                  >
                    {{ control?.checkbox?.text?.active }}
                  </ng-container>
                  <ng-container
                    *ngIf="
                      form.controls[control.name].value !==
                        control.checkbox?.activeValue &&
                      control?.checkbox?.text?.inActive
                    "
                  >
                    {{ control?.checkbox?.text?.inActive }}
                  </ng-container>
                </ng-container>
              </mat-checkbox>
            </ng-container>
            <ng-template #defaultCheckbox>
              <mat-checkbox
                [formControlName]="control.name"
                (ngModelChange)="formValueChange(control, form)"
                [disabled]="control?.disabled"
              >
                {{ control.placeholder }}
              </mat-checkbox>
            </ng-template>
          </ng-container>
          <!-- Checkbox -->

          <!-- Multiple Select Checkbox -->
          <div
            *ngSwitchCase="'multicheckbox'"
            fxLayout="row"
            fxLayoutGap="14px"
            class="multi-checkbox"
          >
            <div class="label" fxFlex="30%">
              {{ control.placeholder }}
              <span *ngIf="control.required?.value"> *</span>
            </div>
            <div
              fxLayout="row wrap"
              fxFlex="70%"
              fxLayoutAlign="space-between center"
            >
              <ng-container *ngIf="control?.isGrouped">
                <div class="multicheckbox-group-container">
                  <div
                    class="multicheckbox-group"
                    *ngFor="let group of control.groupedValues"
                  >
                    <div class="multicheckbox-label">
                      {{ group?.group }}
                    </div>
                    <ng-container *ngFor="let each of group.values">
                      <ng-container
                        *ngTemplateOutlet="
                          multiCheckbox;
                          context: {
                            each,
                            control,
                            form
                          }
                        "
                      >
                      </ng-container>
                    </ng-container>
                  </div>
                </div>
              </ng-container>
              <ng-container *ngIf="!control?.isGrouped">
                <ng-container *ngFor="let each of control.values">
                  <ng-container
                    *ngTemplateOutlet="
                      multiCheckbox;
                      context: {
                        each,
                        control,
                        form
                      }
                    "
                  >
                  </ng-container>
                </ng-container>
              </ng-container>
            </div>
          </div>
          <!-- Multiple Select Checkbox -->

          <!-- Date -->
          <ng-container *ngSwitchCase="'date'">
            <mat-form-field
              [appearance]="control.outline ? 'outline' : 'standard'"
            >
              <mat-label>
                {{ control.placeholder }}
                <span *ngIf="control.required?.value"> *</span>
              </mat-label>
              <input
                matInput
                [owlDateTime]="dt"
                [formControlName]="control.name"
                [owlDateTimeTrigger]="dt"
                [selectMode]="control.date?.enabledRange ? 'range' : 'single'"
                [min]="
                  control.date?.dateRange?.minDate
                    ? control.date.dateRange.minDate
                    : undefined
                "
                [max]="
                  control.date?.dateRange?.maxDate
                    ? control.date.dateRange.maxDate
                    : undefined
                "
                (ngModelChange)="
                  formValueChange(control, form);
                  control.fieldChangeCapture
                    ? patchValueOnAnotherField(control)
                    : ''
                "
                [readonly]="control?.disabled"
              />

              <pp-icon
                matPrefix
                *ngIf="control.prefixIcon"
                [iconConfig]="control.prefixIcon"
                [owlDateTimeTrigger]="dt"
                [disabled]="control?.disabled"
              ></pp-icon>
              <pp-icon
                matSuffix
                *ngIf="control.suffixIcon"
                [iconConfig]="control.suffixIcon"
                [owlDateTimeTrigger]="dt"
                [disabled]="control?.disabled"
              ></pp-icon>
            </mat-form-field>
            <owl-date-time
              #dt
              [pickerType]="control.date?.enabledTime ? 'both' : 'calendar'"
              [disabled]="control?.disabled"
            ></owl-date-time>
          </ng-container>
          <!-- Date -->

          <!-- Time -->
          <ng-container *ngSwitchCase="'time'">
            <mat-form-field
              [appearance]="control.outline ? 'outline' : 'standard'"
            >
              <mat-label>
                {{ control.placeholder }}
                <span *ngIf="control.required?.value"> *</span>
              </mat-label>
              <input
                matInput
                [owlDateTime]="timePicker"
                [formControlName]="control.name"
                [owlDateTimeTrigger]="timePicker"
                [selectMode]="control.date?.enabledRange ? 'range' : 'single'"
                (ngModelChange)="formValueChange(control, form)"
                [readonly]="control?.disabled"
              />

              <pp-icon
                matPrefix
                *ngIf="control.prefixIcon"
                [iconConfig]="control.prefixIcon"
                [owlDateTimeTrigger]="timePicker"
                [disabled]="control?.disabled"
              ></pp-icon>
              <pp-icon
                matSuffix
                *ngIf="control.suffixIcon"
                [iconConfig]="control.suffixIcon"
                [owlDateTimeTrigger]="timePicker"
                [disabled]="control?.disabled"
              ></pp-icon>
            </mat-form-field>
            <owl-date-time
              #timePicker
              [pickerType]="'timer'"
              [disabled]="control?.disabled"
            ></owl-date-time>
          </ng-container>
          <!-- Time -->

          <!-- Toggle -->
          <div *ngSwitchCase="'toggle'" class="toggle">
            <mat-label>
              {{ control.placeholder }}
              <span *ngIf="control.required?.value"> *</span>
            </mat-label>
            <ng-container *ngIf="control.checkbox; else defaultCheckbox">
              <mat-slide-toggle
                (change)="
                  $event.checked
                    ? form.controls[control.name].setValue(
                        control.checkbox?.activeValue
                      )
                    : form.controls[control.name].setValue(
                        control.checkbox?.inActiveValue
                      );
                  formValueChange(control, form)
                "
                [checked]="
                  form.controls[control.name].value ===
                  control.checkbox?.activeValue
                "
                [disabled]="control?.disabled"
              ></mat-slide-toggle>
            </ng-container>
            <ng-template #defaultCheckbox>
              <mat-slide-toggle
                [formControlName]="control.name"
                (ngModelChange)="formValueChange(control, form)"
                [disabled]="control?.disabled"
              >
              </mat-slide-toggle>
            </ng-template>
          </div>
          <!-- Toggle -->

          <!-- Rich Text Editor -->
          <ng-container *ngSwitchCase="'rich-textarea'">
            {{ control.placeholder }}
            <div class="ql-rich-text">
              <input
                type="file"
                name="my-file"
                style="display: none"
                onchange=""
              />

              <editor
                [init]="configForCkEditer"
                [formControlName]="control.name"
              ></editor>
            </div>
          </ng-container>
          <!-- Rich Text Editor -->

          <!-- Autocomplete -->
          <span *ngSwitchCase="'autocomplete'" class="autocomplete-container">
            <ng-container *ngIf="control.autoComplete.type === 'local'">
              <mat-form-field
                [appearance]="control.outline ? 'outline' : 'standard'"
              >
                <mat-label>
                  {{ control.placeholder }}
                  <span *ngIf="control.required?.value"> *</span>
                </mat-label>
                <input
                  type="text"
                  matInput
                  [matAutocomplete]="auto"
                  [(ngModel)]="control.autoComplete.autocompleteSearchText"
                  [ngModelOptions]="{ standalone: true }"
                  [readonly]="control?.disabled"
                  [disabled]="control?.disabled"
                />
                <pp-icon
                  matPrefix
                  *ngIf="control.prefixIcon"
                  [iconConfig]="control.prefixIcon"
                >
                </pp-icon>
                <pp-icon
                  matSuffix
                  *ngIf="control.suffixIcon"
                  [iconConfig]="control.suffixIcon"
                >
                </pp-icon>
              </mat-form-field>
              <mat-autocomplete
                #auto="matAutocomplete"
                (optionSelected)="
                  setValueToAutocomplete($event.option.value, control, form);
                  formValueChange(control, form)
                "
              >
                <mat-option
                  *ngFor="
                    let option of control.values
                      | filterList: control.autoComplete.autocompleteSearchText
                  "
                  [value]="option"
                  >{{ option.viewValue }}</mat-option
                >
              </mat-autocomplete>
            </ng-container>
            <ng-container *ngIf="control.autoComplete.type === 'api'">
              <mat-form-field
                [appearance]="control.outline ? 'outline' : 'standard'"
              >
                <mat-label>
                  {{ control.placeholder }}
                  <span *ngIf="control.required?.value"> *</span>
                </mat-label>
                <input
                  type="text"
                  matInput
                  [(ngModel)]="control.autoComplete.autocompleteSearchText"
                  [ngModelOptions]="{ standalone: true }"
                  [matAutocomplete]="auto"
                  (ngModelChange)="
                    getAutocompletes(control, form, autoCompletespinner)
                  "
                  [readonly]="control?.disabled"
                  [disabled]="control?.disabled"
                />
                <mat-spinner #autoCompletespinner [diameter]="15"></mat-spinner>
                <pp-icon
                  matPrefix
                  *ngIf="control.prefixIcon"
                  [iconConfig]="control.prefixIcon"
                >
                </pp-icon>
                <pp-icon
                  matSuffix
                  *ngIf="control.suffixIcon"
                  [iconConfig]="control.suffixIcon"
                >
                </pp-icon>
              </mat-form-field>
              <mat-autocomplete
                #auto="matAutocomplete"
                (optionSelected)="
                  setValueToAutocomplete($event.option.value, control, form);
                  formValueChange(control, form)
                "
              >
                <mat-option
                  *ngFor="let option of control.values"
                  [value]="option"
                  >{{ option.viewValue }}
                </mat-option>
              </mat-autocomplete>
            </ng-container>
          </span>
          <!-- Autocomplete -->

          <!-- Image -->
          <span *ngSwitchCase="'image'" class="image-container">
            <mat-form-field
              floatLabel="never"
              [appearance]="control.outline ? 'outline' : 'standard'"
            >
              <mat-label>
                {{ control.placeholder }}
                <span *ngIf="control.required?.value"> *</span>
              </mat-label>
              <ngx-mat-file-input
                [accept]="control.file.acceptType"
                [multiple]="control.file.multipleSelect"
                (change)="
                  upload($event, control, imageSpinner, removableInput, form)
                "
                [disabled]="
                  control?.disabled ||
                  (control.file.limit &&
                    form.controls[control.name].value &&
                    form.controls[control.name].value.length ===
                      control.file.limit)
                "
                #removableInput
              >
              </ngx-mat-file-input>
              <div
                class="images"
                fxLayout="row"
                fxLayoutAlign="start none"
                fxLayoutGap="20px"
                *ngIf="form.controls[control.name].value"
              >
                <ng-container
                  *ngIf="
                    control.file.multipleSelect &&
                    _.isArray(form.controls[control.name].value) &&
                    form.controls[control.name].value.length
                  "
                >
                  <div
                    fxFlex
                    *ngFor="
                      let eachPath of form.controls[control.name].value;
                      let imgIndex = index
                    "
                    class="image-element"
                  >
                    <img [src]="eachPath.viewValue" alt="img" />
                    <mat-icon
                      class="clear-icon"
                      (click)="
                        removeFile($event, control, imgIndex, form);
                        formValueChange(control, form)
                      "
                    >
                      clear
                    </mat-icon>
                  </div>
                </ng-container>
                <ng-container *ngIf="!control.file.multipleSelect">
                  <div
                    fxFlex
                    class="image-element"
                    *ngIf="form.controls[control.name].value.value"
                  >
                    <img
                      [src]="form.controls[control.name].value.viewValue"
                      alt="img"
                    />
                    <mat-icon
                      class="clear-icon"
                      (click)="
                        $event.stopPropagation();
                        form.controls[control.name].setValue('');
                        formValueChange(control, form)
                      "
                    >
                      clear
                    </mat-icon>
                  </div>
                </ng-container>
              </div>
              <mat-spinner [diameter]="15" #imageSpinner></mat-spinner>
              <pp-icon
                matPrefix
                *ngIf="control.prefixIcon && !form.controls[control.name].value"
                [iconConfig]="control.prefixIcon"
              ></pp-icon>
              <pp-icon
                matSuffix
                *ngIf="control.suffixIcon && !form.controls[control.name].value"
                [iconConfig]="control.suffixIcon"
              ></pp-icon>
              <div
                *ngIf="control?.helperText"
                style="display: flex; gap: 4px; align-items: center"
              >
                <mat-icon>info</mat-icon>
                <div [innerHTML]="control.helperText | safe: 'html'"></div>
              </div>
            </mat-form-field>
          </span>
          <!-- Image -->

          <!-- Document -->
          <span *ngSwitchCase="'document'" class="document-container">
            <mat-form-field
              floatLabel="never"
              [appearance]="control.outline ? 'outline' : 'standard'"
            >
              <mat-label>
                {{ control.placeholder }}
                <span *ngIf="control.required?.value"> *</span>
              </mat-label>
              <ngx-mat-file-input
                [accept]="control.file.acceptType"
                [multiple]="control.file.multipleSelect"
                (change)="
                  upload($event, control, docSpinner, removableInput, form)
                "
                [disabled]="
                  control?.disabled ||
                  (control.file.limit &&
                    form.controls[control.name].value &&
                    form.controls[control.name].value.length ===
                      control.file.limit)
                "
                #removableInput
              >
              </ngx-mat-file-input>
              <div class="documents">
                <ng-container *ngIf="form.controls[control.name].value">
                  <ng-container
                    *ngIf="
                      control.file.multipleSelect &&
                      _.isArray(form.controls[control.name].value) &&
                      form.controls[control.name].value.length
                    "
                  >
                    <span
                      *ngFor="
                        let eachPath of form.controls[control.name].value;
                        let docIndex = index
                      "
                    >
                      <div
                        (click)="
                          $event.stopPropagation();
                          openPreview(eachPath.viewValue)
                        "
                        *ngIf="!control.file?.isAudio"
                        class="docSec"
                      >
                        <mat-icon class="doc" matTooltip="{{ eachPath.name }}">
                          description
                        </mat-icon>
                      </div>
                      <mat-icon
                        class="clear-icon"
                        (click)="
                          removeFile($event, control, docIndex, form);
                          formValueChange(control, form)
                        "
                      >
                        clear
                      </mat-icon>
                    </span>
                  </ng-container>

                  <ng-container *ngIf="!control.file.multipleSelect">
                    <span *ngIf="form.controls[control.name].value.value">
                      <div
                        (click)="
                          $event.stopPropagation();
                          openPreview(
                            form.controls[control.name].value.viewValue
                          )
                        "
                        *ngIf="!control.file?.isAudio"
                        class="docSec"
                      >
                        <mat-icon
                          class="doc"
                          matTooltip="{{
                            form.controls[control.name].value.name
                          }}"
                        >
                          description
                        </mat-icon>
                      </div>

                      <audio
                        *ngIf="control.file?.isAudio"
                        class="audio"
                        controls
                        [src]="form.controls[control.name].value.viewValue"
                      ></audio>
                      <mat-icon
                        class="clear-icon"
                        (click)="
                          $event.stopPropagation();
                          form.controls[control.name].setValue('');
                          formValueChange(control, form)
                        "
                      >
                        clear
                      </mat-icon>
                    </span>
                  </ng-container>
                </ng-container>
              </div>
              <mat-spinner [diameter]="15" #docSpinner></mat-spinner>
              <pp-icon
                matPrefix
                *ngIf="control.prefixIcon"
                [iconConfig]="
                  control.prefixIcon && !form.controls[control.name].value
                "
              ></pp-icon>
              <pp-icon
                matSuffix
                *ngIf="control.suffixIcon && !form.controls[control.name].value"
                [iconConfig]="control.suffixIcon"
              ></pp-icon>
            </mat-form-field>
          </span>
          <!-- Document -->

          <!-- Tags/Chips -->
          <ng-container *ngSwitchCase="'tags'">
            <mat-form-field
              class="tags-container"
              [appearance]="control.outline ? 'outline' : 'standard'"
            >
              <mat-label>
                {{ control.placeholder }}
                <span *ngIf="control.required?.value"> *</span>
              </mat-label>
              <mat-chip-list #chipList aria-label="tag selection">
                <!-- Tags type Default -->
                <ng-container *ngIf="control.tags.type === 'default'">
                  <ng-container
                    *ngIf="
                      form.controls[control.name].value &&
                      _.isArray(form.controls[control.name].value)
                    "
                  >
                    <mat-chip
                      *ngFor="
                        let each of form.controls[control.name].value;
                        let index = index
                      "
                      (removed)="
                        form.controls[control.name].value.splice(index, 1);
                        formValueChange(control, form)
                      "
                      [disabled]="control?.disabled"
                    >
                      {{ each }}
                      <mat-icon matChipRemove>cancel</mat-icon>
                    </mat-chip>
                  </ng-container>
                  <input
                    [matChipInputFor]="chipList"
                    (matChipInputTokenEnd)="
                      addTags($event, control, form);
                      formValueChange(control, form)
                    "
                    [disabled]="control?.disabled"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  />
                </ng-container>
                <!-- Tags type Default -->

                <!-- Tags type Select -->
                <ng-container *ngIf="control.tags.type === 'select'">
                  <ng-container
                    *ngIf="
                      form.controls[control.name].value &&
                      _.isArray(form.controls[control.name].value)
                    "
                  >
                    <mat-chip
                      *ngFor="
                        let each of form.controls[control.name].value;
                        let index = index
                      "
                      (removed)="
                        form.controls[control.name].value.splice(index, 1);
                        formValueChange(control, form)
                      "
                    >
                      {{ getDisplayValueForTags(each, control.values) }}
                      <mat-icon matChipRemove>cancel</mat-icon>
                    </mat-chip>
                  </ng-container>
                  <input
                    [matChipInputFor]="chipList"
                    [matAutocomplete]="auto"
                    #autocompleteTags
                    [disabled]="control?.disabled"
                  />
                  <mat-autocomplete
                    #auto="matAutocomplete"
                    (optionSelected)="
                      addTagsFromAutocomplete(
                        $event.option.value,
                        control,
                        autocompleteTags,
                        form
                      );
                      formValueChange(control, form)
                    "
                  >
                    <mat-option
                      *ngFor="
                        let option of getDisplayOptionsForTags(
                          control.values,
                          form.controls[control.name].value
                        ) | filterList: autocompleteTags.value
                      "
                      [value]="option.value"
                    >
                      {{ option.viewValue }}
                    </mat-option>
                  </mat-autocomplete>
                </ng-container>
                <!-- Tags type Select -->
              </mat-chip-list>
              <pp-icon
                matPrefix
                *ngIf="control.prefixIcon"
                [iconConfig]="control.prefixIcon"
              ></pp-icon>
              <pp-icon
                matSuffix
                *ngIf="control.suffixIcon"
                [iconConfig]="control.suffixIcon"
              ></pp-icon>
            </mat-form-field>
          </ng-container>

          <!-- Tags/Chips -->

          <!-- Groups -->
          <ng-container *ngSwitchCase="'group'">
            <div [formGroupName]="control.name">
              <div *ngIf="control.placeholder">
                <h3>{{ control.placeholder }}</h3>
              </div>
              <div class="item">
                <br />
                <div class="content">
                  <ng-container
                    *ngTemplateOutlet="
                      formFieldTemplate;
                      context: {
                        fields: control.formFields,
                        formGrp: form.controls[control.name],
                        columnPerRow: control.columnPerRow || 1
                      }
                    "
                  >
                  </ng-container>
                </div>
              </div>
            </div>
          </ng-container>
          <!-- Groups -->

          <!-- Form Array -->
          <ng-container *ngSwitchCase="'array'">
            <div *ngIf="control.placeholder">
              <h3>{{ control.placeholder }}</h3>
            </div>
            <div
              [formArrayName]="control.name"
              *ngFor="
                let each of form.controls[control.name].controls;
                let i = index
              "
            >
              <div class="item">
                <br />
                <div class="content">
                  <ng-container
                    *ngTemplateOutlet="
                      formFieldTemplate;
                      context: {
                        fields: each.formFields || control.formFields,
                        formGrp: form.controls[control.name].controls[i],
                        columnPerRow: control.columnPerRow || 1
                      }
                    "
                  >
                  </ng-container>
                  <div
                    *ngIf="
                      control.formArray?.deleteButton &&
                      form.controls[control.name].controls.length >
                        (control.formArray?.deleteLastElement ?? 0)
                    "
                  >
                    <pp-button
                      [buttonConfig]="control.formArray.deleteButton"
                      (onClick)="
                        form.controls[control.name].removeAt(i);
                        formValueChange(control, form)
                      "
                    ></pp-button>
                  </div>
                  <br />
                </div>
                <br />
              </div>
            </div>
            <div
              *ngIf="
                (control.formArray?.addButton &&
                  form.controls[control.name]?.length <
                    control.formArray?.limit) ||
                !control.formArray?.limit
              "
            >
              <pp-button
                [buttonConfig]="control.formArray.addButton"
                (onClick)="addNewToFormArray(form, control)"
              ></pp-button>
            </div>
          </ng-container>
          <!-- Form Array -->

          <!-- Validation Errors -->
          <ng-container>
            <div
              *ngIf="
                form.controls[control.name] &&
                form.controls[control.name].invalid &&
                form.controls[control.name].errors &&
                (form.controls[control.name].dirty ||
                  form.controls[control.name].touched)
              "
            >
              <mat-error *ngIf="form.controls[control.name].errors.required">
                {{ control.required?.errorMessage }}
              </mat-error>
              <mat-error *ngIf="form.controls[control.name].errors.pattern">
                {{ control.pattern?.errorMessage }}
              </mat-error>
              <mat-error
                *ngIf="form.controls[control.name].errors.relativeEqual"
              >
                {{ form.controls[control.name].errors.relativeEqual }}
              </mat-error>
              <mat-error
                *ngIf="form.controls[control.name].errors.relativeRequired"
              >
                {{ form.controls[control.name].errors.relativeRequired }}
              </mat-error>
              <mat-error
                *ngIf="form.controls[control.name].errors.relativeNotEqual"
              >
                {{ form.controls[control.name].errors.relativeNotEqual }}
              </mat-error>
              <mat-error *ngIf="form.controls[control.name].errors.relativeMin">
                {{ form.controls[control.name].errors.relativeMin }}
              </mat-error>
              <mat-error *ngIf="form.controls[control.name].errors.relativeMax">
                {{ form.controls[control.name].errors.relativeMax }}
              </mat-error>
              <mat-error
                *ngIf="form.controls[control.name].errors.asyncValidationError"
              >
                {{ form.controls[control.name].errors.asyncValidationError }}
              </mat-error>
            </div>
          </ng-container>
          <!-- Validation Errors -->
          <mat-hint
            *ngIf="control?.disabled && control?.relativeValidation?.length"
            class="relative-disabled-message"
          >
            {{ disabledMessage(control) }}
          </mat-hint>
        </ng-container>
      </div>
    </ng-container>
  </div>
</ng-template>
<!-- Form Fields -->

<ng-template
  #multiCheckbox
  let-each="each"
  let-control="control"
  let-form="form"
>
  <mat-checkbox
    class="multicheckbox"
    (change)="
      multiSelectCheckboxChange(each, control, form);
      formValueChange(control, form)
    "
    [checked]="isMultiCheckboxFieldChecked(each, control, form)"
    [disabled]="control?.disabled"
    [disableRipple]="true"
  >
    {{ each.viewValue }}
  </mat-checkbox>
</ng-template>
